import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ThreadsIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm0 14H5.17L4 17.17V4h16v12ZM6 12h2v2H6v-2Zm0-3h2v2H6V9Zm0-3h2v2H6V6Zm4 6h5v2h-5v-2Zm0-3h8v2h-8V9Zm0-3h8v2h-8V6Z" />
  </Icon>
);

export default memo(ThreadsIcon);
